import { render, staticRenderFns } from "./ClientAttribution.vue?vue&type=template&id=17b00b30&scoped=true"
import script from "./ClientAttribution.vue?vue&type=script&lang=js"
export * from "./ClientAttribution.vue?vue&type=script&lang=js"
import style0 from "./ClientAttribution.vue?vue&type=style&index=0&id=17b00b30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b00b30",
  null
  
)

export default component.exports